import React, {Component} from 'react';
import EditorToolsSpace, {HEIGHT} from "./editorToolsSpace";


const toolWidth = 44;
/**
 * 一行下工具两端对齐 工具空间
 */
class OneLineToolSpace extends EditorToolsSpace {

    render() {
        let tools = this.props.tools;
        if(!tools || tools.length === 0){
            return <div/>;
        }

        return (
            <div height={HEIGHT} style={{width:`${toolWidth * tools.length}px`}}>
                {tools.map((item, index)=>{
                    return this.getToolComponent(item, {editor:window.ueditor, width: toolWidth, height: HEIGHT, key:index});
                })}
            </div>
        );
    }
}


export class BigButtonTool extends Component{
    static defaultProps = {
        style:{},
        imgWidth:28,
        float: "left",
        onClick:()=>{}
    };
    render() {
        return <table style={{float: this.props.float, cursor:"pointer", ...this.props.style}}
                      cellPadding={0} cellSpacing={0} border={0} width={this.props.width} height={this.props.height}
                      onClick={()=>{this.props.onClick()}}
        >
            <tbody>
                <tr>
                    <td align={"center"} height={35}><img width={this.props.imgWidth} src={this.props.src}/></td>
                </tr>
                <tr>
                    <td align={"center"} valign={"top"}>{this.props.text}</td>
                </tr>
            </tbody>
        </table>
    }
}

export default OneLineToolSpace;